import React from 'react';
import pluralize from 'pluralize';

import RelatedWorksCard, { Props as RWProps } from './RelatedWorksCard';

type Props = {
  author: string;
  count: number;
} & RWProps;

const AuthorMoreWorksCard: React.FC<Props> = (props: Props) => {
  const headerText = `${props.count} ${pluralize('more', props.count)} by ${props.author}`;
  return <RelatedWorksCard {...props} limit={1} headerText={headerText} />;
};

export default AuthorMoreWorksCard;
